// extracted by mini-css-extract-plugin
module.exports = {"container":"License_container__29rz7","license_img":"License_license_img__293Ao"};